<script setup lang="ts">
import Alerts from './Alerts.vue'
import useApp from '@/composables/useApp'

const { notifications, removeNotification } = useApp()
</script>

<template>
  <div class="alert-panel-container">
    <TransitionGroup tag="ul" name="alert" id="alert-sequence">
      <alerts
        @remove="removeNotification(alert.id)"
        v-for="(alert, index) in notifications"
        :key="index"
        :notification="alert"
        :class="{
          child1: index === 0,
          child2: index === 1,
          child3: index === 2,
        }"
      />
    </TransitionGroup>
  </div>
</template>

<style scoped>
.alert-panel-container {
  position: fixed;
  z-index: 600;
  height: auto;
  left: 50%;
  top: 3.1rem;
  width: 28em;
  transform: translate(-50%);
}

#alert-sequence {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.child1 {
  transform: scale(1) translateY(0);
  transform-origin: center;
  opacity: 1;
  z-index: 3;
}

.child2 {
  transform: scale(0.85) translateY(-25%);
  transform-origin: center;
  opacity: 0.9;
  z-index: 2;
}

.child3 {
  transform: scale(0.75) translateY(-75%);
  transform-origin: center;
  opacity: 0.9;
  z-index: 0;
}

.child4 {
  transform: scale(0.65) translateY(-150%);
  transform-origin: center;
  opacity: 0.9;
  z-index: 0;
}

.child5 {
  transform: scale(0.55) translateY(-275%);
  transform-origin: center;
  opacity: 0.9;
  z-index: 0;
}

.alert-enter-active {
  transition: all 400ms ease-out;
}

.alert-leave-active {
  position: absolute;
  bottom: 0;
  z-index: -100;
  transition: all 300ms ease-out;
}

.alert-move {
  transition: all 400ms ease-out;
}

.alert-enter-from {
  opacity: 0;
  transform: translateY(-80%);
}

.alert-leave-to {
  opacity: 0;
  transform: translateX(-45%) scale(0.5);
}
</style>
